import {Observable} from 'rxjs';
import {OO8OrganizationApiModel} from '../../../../oo8-api-typescript/models/common/oo8-organization.api-model';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

/**
 * OO8 Api Service
 */
export class CpmCOO8ApiService {
    public static baseUrl(inCustomerUUID: string | undefined) {
        const base = CpmCApiBridge.getBackendBaseURL() + 'api/core/v1/';
        const customerUUID = CpmCApiBridge.getCurrentCustomerUUID();

        return base + `customer/${customerUUID || inCustomerUUID}/oo8`;
    }

    // ===============================================================
    // ===============================================================

    public static endpointOrganizationList(inCustomerUUID: string | undefined): string {
        return `${CpmCOO8ApiService.baseUrl(inCustomerUUID)}/organization/list`;
    }

    // ===============================================================
    // ===============================================================

    public static getOO8OrganizationList(): Observable<CpmCPaginatedResultAPISchema<OO8OrganizationApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<OO8OrganizationApiModel>>(
            CpmCOO8ApiService.endpointOrganizationList(undefined),
            undefined
        );
    }
}
